import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { WarehousePickerGroupsDataGrid } from "src/components/views/erp/warehouse/masterData/WarehousePickerGroupsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/warehouse/warehousePickerGroups")({
	staticData: { title: i18n.t("picker_groups"), legacyViewKey: "warehousePickerGroupsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <WarehousePickerGroupsDataGrid />;
}
